import React from "react";
import { cn } from "@/lib/utils";

export const Container = ({
    children,
    size = "lg",
    className,
    style, // Universal Style Prop
    // Extract non-DOM props to prevent React warnings
    editMode,
    puck,
    onUpdateProps,
    isSelected,
    layers, // unused in DOM directly
    id,
    // Legacy props to ignore
    fluid,
    maxWidth,
    backgroundColor,
    flexDirection,
    ...rest
}: any) => {

    // Consistent sizing
    const sizeMap: Record<string, string> = {
        sm: "max-w-3xl",
        md: "max-w-5xl",
        lg: "max-w-7xl",
        xl: "max-w-[90rem]",
        full: "max-w-full",
    };

    return (
        <div
            id={id}
            className={cn(
                "container mx-auto px-4 sm:px-6 w-full relative min-h-[50px]",
                sizeMap[size] || "max-w-7xl",
                className
            )}
            style={style}
            {...rest}
        >
            {children}
        </div>
    );
};
